export const LOCK_LOADING_GENERAL_APP = "LOCK_LOADING_GENERAL_APP";
export const SET_EVENT_NAME_SHOW_BLUR = "SET_EVENT_NAME_SHOW_BLUR";
export const SET_ROWS_AREA = "SET_ROWS_AREA";
export const SET_ERROR_CODES = "SET_ERROR_CODES";